import actionTypes from '../actionTypes';

const initialState = {
  workOwnerships: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.WORK_OWNERSHIPS_SET:
      return { ...state, workOwnerships: action.workOwnerships };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// src/redux/reducers/workOwnerships.js